var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-4961 1141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M10.75,5h0A1.25,1.25,0,0,1,9.5,3.75V2.25a1.25,1.25,0,1,1,2.5,0v1.5A1.25,1.25,0,0,1,10.75,5Z",
    transform: "translate(4956.75 -1141)",
    fill: "rgba(0,0,0,0)",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M34.75,5h0A1.25,1.25,0,0,1,33.5,3.75V2.25a1.25,1.25,0,1,1,2.5,0v1.5A1.25,1.25,0,0,1,34.75,5Z",
    transform: "translate(4944.75 -1141)",
    fill: "rgba(0,0,0,0)",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M24,24.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4950.25 -1152.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M12,24.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4956.25 -1152.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M36,24.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4944.25 -1152.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M24,34.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4950.25 -1157.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M12,34.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4956.25 -1157.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M36,34.25a.75.75,0,1,0-.75.75.75.75,0,0,0,.75-.75",
    transform: "translate(4944.25 -1157.25)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x2: 19,
    transform: "translate(4965 -1132)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M42.75,17.5V7a2,2,0,0,0-2-2H38.5",
    transform: "translate(4942.25 -1143)",
    fill: "rgba(0,0,0,0)",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M5,5H3A2,2,0,0,0,1,7V23a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V20",
    transform: "translate(4961 -1143)",
    fill: "rgba(0,0,0,0)",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    x2: 7,
    transform: "translate(4970 -1138)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date-picker-icon.01d8a524063d16eccc12b5b5f3e6f3b9.svg";
export { ForwardRef as ReactComponent };